import React, { useState } from "react";
import { BACKEND_URL } from "../../lib/backend";
import { initials } from "../../lib/events";

/** Organiser logo from the official domain (served by our API) — falls back to initials. */
export function EventLogo({ event, size = 44, dm, className = "" }) {
  const [broken, setBroken] = useState(false);
  const src = event.logo_url && !broken ? `${BACKEND_URL}${event.logo_url}` : null;
  const style = { width: size, height: size, minWidth: size, fontSize: Math.max(10, Math.round(size * 0.3)) };
  return (
    <span
      data-testid={`event-logo-${event.id}`}
      style={style}
      className={`inline-flex items-center justify-center rounded-xl overflow-hidden border font-bold tracking-tight ${
        dm ? "bg-[#0f1718] border-slate-700/60 text-cyan-300" : "bg-white border-[#e7e8e9] text-[#006874]"
      } ${className}`}
    >
      {src ? (
        <img src={src} alt="" loading="lazy" onError={() => setBroken(true)} className="w-full h-full object-contain p-1" />
      ) : (
        <span aria-hidden="true">{initials(event.name) || "•"}</span>
      )}
    </span>
  );
}

export default EventLogo;
